<template>
	<vxe-modal v-model="modalShow" width="1000" height="1000" show-footer @show="init">
		<template #title>
			<span>{{title}}</span>
		</template>
		<!-- 		<template #corner>
			<vxe-icon name="bell-fill"></vxe-icon>
			<vxe-icon name="minus"></vxe-icon>
		</template> -->
		<template #default>
			<div class="full flex" style="flex-direction: column;" ref="filemodel">
				<div ref="wordarticle" style="overflow: auto;flex: 1;">
					<div class="audit_preload_box zhang" id="audit_preload_box"></div>
				</div>
			</div>
		</template>
		<template slot="footer" v-if="type=='download'">
			<vxe-button status="primary" content="下载" @click="download"></vxe-button>
		</template>
		<template slot="footer" v-if="type!='download'">
			<vxe-button content="取消审核" @click="cancle"></vxe-button>
			<vxe-button status="primary" content="确认审核" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style>

</style>

<script>
	import html2canvas from 'html2canvas';
	import {
		renderAsync
	} from 'docx-preview'
	import {
		jsPDF
	} from "jspdf";
	export default {
		name: '',
		props: {
			type: {
				type: String,
				default: () => {
					return 'preview'
				}
			},
			form: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			comapnyid: {

				default: () => {
					return 0
				}
			},			
			
			
		},
		data() {
			return {
				modalShow: false,
				htmlContent: '',
				title: '',
				targetnode:[],
				hasseal:false
			}
		},
		watch: {

		},
		mounted() {
			
		},
		computed: {

		},

		methods: {
			init() {
				this.hasseal = this.row.audit==5?true:false
				this.targetnode = []
				const wordarticle = this.$refs.wordarticle
				wordarticle.scrollTop = 0
				let file = this.row.file[0]
				this.title = this.row.name
				this.$api.upload.download({
					path: file.path,
					name: file.name,
					filetype: 'DOCX'
				}).then((res) => {
					this.previewDOCX(res)

				})
			},
			//http://47.98.231.105/api/public/storage/company/20230731/fb59897377b510c9e1c55c813769808a.png
			previewDOCX(res) {
				let blob = new Blob([res.data])
				let reader = new FileReader()
				reader.readAsArrayBuffer(new window.File([blob], res.name, {
					type: 'blob'
				}))
				reader.onload = (e) => {
					let data = e.target.result
					renderAsync(data, document.getElementById("audit_preload_box"), null, {
						className: "docx", // 默认和文档样式类的类名/前缀
						inWrapper: true, // 启用围绕文档内容渲染包装器
						ignoreWidth: false, // 禁止页面渲染宽度
						ignoreHeight: false, // 禁止页面渲染高度
						ignoreFonts: false, // 禁止字体渲染
						breakPages: true, // 在分页符上启用分页
						ignoreLastRenderedPageBreak: true, //禁用lastRenderedPageBreak元素的分页
						experimental: false, //启用实验性功能（制表符停止计算）
						trimXmlDeclaration: true, //如果为真，xml声明将在解析之前从xml文档中删除
						debug: false, // 启用额外的日志记录
					}).then(() => {
						let targetTag = document.getElementsByTagName('article')
						this.findElementWithText(targetTag[0], '盖章区')
						this.targetnode.forEach((node)=>{
							let button = document.createElement("button")
							if(this.type=='audit'){		
								button.innerHTML = '盖章区'
								node.innerHTML = "";
								node.addEventListener('click', () => {
									this.audit()
								});
							}else{
								button = document.createElement("div")
								button.innerHTML = '盖章区'
								button.disabled = true
								node.innerHTML = "";
							}
							node.appendChild(button)
						})
						// if (node) {		
						// 	let button = document.createElement("button")
						// 	if(this.type=='audit'){		
						// 		button.innerHTML = '盖章区'
						// 		node.innerHTML = "";
						// 		node.addEventListener('click', () => {
						// 			this.audit()
						// 		});
						// 	}else{
						// 		button = document.createElement("div")
						// 		button.innerHTML = '盖章区'
						// 		button.disabled = true
						// 		node.innerHTML = "";
						// 	}
						// 	node.appendChild(button)
						// }
						
						
						if (this.row.audit == 5) {
							this.audit()
						}
					})


				}
			},
			audit() {
				var targetTag = document.getElementsByTagName('article');
				
				this.findElementWithText(targetTag[0], '盖章区')
				this.targetnode.forEach((node)=>{
					let companyid = this.comapnyid
					if(!companyid){
						this.$message.error('未选择供方公司')
						return
					}
					this.$api.company.getseal(companyid).then((res)=>{
						if(!res || res.length==0){
							this.$message.error('电子章未获取')
							return
						}
						let imgNode = document.createElement("img");
						imgNode.classList.add("zhang")
						imgNode.src = res[0].url+'?'+Math.random(); // 用你的图片 URL 替换这里
						imgNode.style = "width:100px;margin-top:-50px;margin-left:-20px;"
						node.parentNode.replaceChild(imgNode, node);
						this.hasseal = true
					})
				})
				
			},
			findElementWithText(node, string) {
				if (node.nodeType === 1 && node.textContent.includes(string)) { // 检查节点类型是否为元素节点
					if (node.innerHTML == string) {
						this.targetnode.push(node)
	
					}
				}
				for (let i = 0; i < node.childNodes.length; i++) {
					let result = this.findElementWithText(node.childNodes[i],string)
					if (result) {
						return result
					}
				}
				return null
			},
			download(){
				this.loading = true
				let scale = 2
				let model = document.getElementsByClassName('docx')[0]
				let rect = model.getBoundingClientRect()
				html2canvas(model, {
					useCORS:true,
					scale: scale,
					scrollY: rect.top,
					height: rect.height + 50
				}).then((canvas) => {
					let timeStamp = new Date().getTime()
					let date = window.systemMethods.timestampToDate(timeStamp, true)
					let title = this.row.name + date
					let contentWidth = canvas.width / scale
					let contentHeight = canvas.height / scale
					let PDF = new jsPDF('p', 'pt', [contentWidth, contentHeight])
					let pdfWidth = PDF.internal.pageSize.getWidth()
					let pdfHeight = contentHeight / contentWidth * pdfWidth
					let pageData = canvas.toDataURL('image/jpeg', 1.0)
					PDF.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
					PDF.save(title + '.pdf')
					this.loading = false
				})
			},
			submit(){
				if(this.hasseal){
					this.row.audit = 5
					this.modalShow = false
				}else{
					this.$message.error('缺少公章')
				}
			},
			cancle(){
				this.row.audit = 6
				this.modalShow = false
			}
		},
		components: {

		}
	}
</script>
